import { createHashRouter, RouterProvider } from 'react-router-dom';
import { ReportPage } from './pages/Report/ReportPage';
import './App.css';

function App() {

  const hashRouter = createHashRouter([
    {
      path: "/",
      element: <ReportPage />,
    },
  ]);

  return (
    <div className="seo-checker-app">
      <div className="seo-checker-app__body">
        <RouterProvider router={hashRouter} />
      </div>
    </div>
  );
}

export default App

